import clsx from 'clsx';
import type { CSSProperties } from 'react';
import { Input as RACInput, type InputProps as RACInputProps } from 'react-aria-components';
import type { CommonProps } from '../../types.js';
import { textStyle } from '../../typography/utils.js';

interface InputProps extends CommonProps, Exclude<RACInputProps, 'className' | 'style'> {
  contentWidth?: CSSProperties['width'];
}

/**
 * Renders a styled input field.
 * @internal
 */
export function Input(props: InputProps) {
  // TODO: find a better way to extract common props, if a new prop is added to `CommonProps` this will break
  const {
    id,
    UNSAFE_className,
    UNSAFE_style,
    'data-cim-style-root': dataCimStyleRoot,

    contentWidth,

    ...inputProps
  } = props;

  return (
    <div
      id={id}
      className={clsx('cim-input', UNSAFE_className)}
      style={UNSAFE_style}
      data-cim-style-root={dataCimStyleRoot}
    >
      <RACInput
        {...inputProps}
        className={clsx('cim-input-control', textStyle({ variant: 'body' }))}
        style={{ '--cim-input-content-width': contentWidth } as CSSProperties}
      />
    </div>
  );
}
